module.exports = __webpack_public_path__ + "img/funnel.eb42273b.svg";